var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStempelform(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Stempelform__Icn/40px/Stempelform",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Stempelform__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Stempelform__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20,10 C25.5228475,10 30,14.4771525 30,20 C30,25.5228475 25.5228475,30 20,30 C14.4771525,30 10,25.5228475 10,20 C10,14.4771525 14.4771525,10 20,10 Z M20,12 C15.581722,12 12,15.581722 12,20 C12,24.418278 15.581722,28 20,28 C24.418278,28 28,24.418278 28,20 C28,15.581722 24.418278,12 20,12 Z M25.4152106,17.41307 C25.790078,18.1963656 26,19.0736679 26,20 C26,23.3137085 23.3137085,26 20,26 C19.0736679,26 18.1963656,25.790078 17.41307,25.4152106 L18.9641347,23.8645726 C19.2945218,23.9529065 19.6417612,24 20,24 C22.209139,24 24,22.209139 24,20 C24,19.6417612 23.9529065,19.2945218 23.8645726,18.9641347 L25.4152106,17.41307 Z M20,14 C20.9267285,14 21.8043852,14.2101017 22.5879355,14.5852707 L21.0368664,16.1356952 C20.7061797,16.0471887 20.3586006,16 20,16 C17.790861,16 16,17.790861 16,20 C16,20.3586006 16.0471887,20.7061797 16.1356952,21.0368664 L14.5852707,22.5879355 C14.2101017,21.8043852 14,20.9267285 14,20 C14,16.6862915 16.6862915,14 20,14 Z",
    id: ".._.._src_svg_Icn_40px_Stempelform__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStempelform);
export default __webpack_public_path__ + "static/media/Stempelform.6559605f0a1a5644cf7a0c7930ef7531.svg";
export { ForwardRef as ReactComponent };